import { render, staticRenderFns } from "./FirmOverview.vue?vue&type=template&id=6d42a711&scoped=true&"
import script from "./FirmOverview.vue?vue&type=script&lang=js&"
export * from "./FirmOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d42a711",
  null
  
)

export default component.exports